import { Col, FormFeedback, Label } from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import { getDate } from '../Common/Util';

const DatePicker = (props: any) => {
    /**
     * Handles date selection and formats it correctly.
     */
    const handleDateChange = (dates: any) => {
        if (!dates || dates.length === 0) return null;

        if (props.pickerMode === 'range') {
            return {
                startDate: dates[0] ? new Date(dates[0]).toISOString() : null,
                endDate: dates[1] ? new Date(dates[1]).toISOString() : null
            };
        }
        return dates[0] ? new Date(dates[0]).toISOString() : null; // Single date case
    };

    /**
     * Determines the correct value to pass to Flatpickr.
     */
    const getFlatpickrValue = () => {
        const value = props.validation.values[props.field?.value];

        if (!value) return undefined; // Ensures Flatpickr doesn't break

        if (props.pickerMode === 'range' && value.startDate && value.endDate) {
            return [new Date(value.startDate), new Date(value.endDate)];
        }
        if (props.pickerMode === 'single') {
            return value ? new Date(value) : undefined;
        }
        return undefined;
    };

    return (
        <Col className="mt-2" xs={props.field?.xs} sm={props.field?.sm} md={props.field?.md} lg={props.field?.lg} xl={props.field?.xl}>
            {props.field?.label && (
                <Label htmlFor={props.field?.value} className={`form-label m-0 ${props.labelCss || ''}`}>
                    {props.field.label}
                    {props.mode !== 'view' && props.field.mandatory ? (
                        <span className="text-danger ps-1"> *</span>
                    ) : (
                        <span className="ps-1"> :</span>
                    )}
                </Label>
            )}

            {props.mode === 'view' ? (
                <span className="ps-1">
                    {props.validation.values[props.field?.value] ? getDate(props.validation.values[props.field?.value], true) : ''}
                </span>
            ) : (
                <div className="input-group flex-nowrap mt-2">
                    <Flatpickr
                        className="form-control w-100"
                        name={props.field?.value}
                        value={getFlatpickrValue()} // Ensures valid date(s)
                        placeholder={`Select ${props.field.label}`}
                        disabled={props.field?.disabled}
                        onChange={(dates) => {
                            const formattedDate = handleDateChange(dates);
                            props.validation.setFieldValue(props.field?.value, formattedDate);

                            if (props.onChange) {
                                props.onChange({
                                    target: { name: props.field?.value, id: props.field?.value, value: formattedDate }
                                });
                            }
                        }}
                        options={{
                            dateFormat: 'd M, Y',
                            mode: props.pickerMode || 'single',
                            minDate: props.pickerMinDate || '',
                            maxDate: props.pickerMaxDate || ''
                        }}
                    />
                    <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line"></i>
                    </div>
                </div>
            )}

            {props.validation.touched[props.field?.value] && props.validation.errors[props.field?.value] ? (
                <FormFeedback type="invalid">
                    <div>{props.validation.errors[props.field?.value]}</div>
                </FormFeedback>
            ) : null}
        </Col>
    );
};

export default DatePicker;
